import React from 'react';
import { Link } from "react-router-dom";

import Logo from '../../../assets/imgs/confirmly-ui-logo.svg';

const Header = () => {

    return (
        <>
            <nav data-testid="header-component" className='navbar navbar-light bg-white' >
                <div className='container-fluid' >
                    <Link to={'/'} className="navbar-brand">
                        <img src={Logo} alt='' width='280' className='d-inline-block align-text-top' />
                    </Link>
                    <div className='d-flex'>
                        <Link data-testid="logout-link" to={`/logout`} className="fs-6 btn btn-outline-dark fw-bold">LOGOUT</Link>
                    </div>
                </div>
            </nav>
            <div className='Rectangle-76'>
                &nbsp;
            </div>
        </>
    );
};

export default Header;

